import { clsx } from 'clsx';
import { FC } from 'react';

import { styled } from '@mui/material/styles';
import FormControlLabel from '@o2/ui/FormControlLabel';
import Switch, { SwitchProps } from '@o2/ui/Switch';

import { useSubheaderUtilityClasses } from '../subheaderClasses';

type SwitchFilterProps = SwitchProps & {
  label: string;
};

const SwitchXsLeftAligned = styled(Switch)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginLeft: -10,
  },
}));

const SwitchFilter: FC<SwitchFilterProps> = ({ label, ...switchProps }) => {
  const utilityClasses = useSubheaderUtilityClasses();

  return (
    <FormControlLabel
      control={<SwitchXsLeftAligned {...switchProps} />}
      label={label}
      className={clsx(utilityClasses.switch)}
    />
  );
};

SwitchFilter.displayName = 'Subheader.SwitchFilter';

export default SwitchFilter;
